import React from "react";
import styled from "styled-components";

// context
import { PanelOverlay as PanelOverlayContext } from "core/SiteHeader/Mobile/components/PanelOverlay/index.js";

// components
import AuthProfile from "core/SiteHeader/components/Auth/AuthProfile";
import LogoutButton from "core/SiteHeader/components/LogoutButton.js";
import AuthMenus from "core/SiteHeader/components/Auth/AuthMenus";
import MarketingMessage, {
    MarketingMessageTextStyled
} from "core/SiteHeader/components/Auth/MarketingMessage.js";

// styles
import { convertPxToRem } from "frontend/components/helpers";
import colors from "core/colors";

// Mobile Menu is always Lightmode
const MarketingMessageStyled = styled(MarketingMessage)`
    ${MarketingMessageTextStyled} {
        color: ${colors.secondary.orca};
        font-size: ${convertPxToRem(15)};
        a {
            color: ${colors.accent.lightMode.persian};

            &:hover {
                color: ${colors.accent.lightMode.pansy};
            }
        }
    }
`;

const PanelOverlayStyled = styled.div`
    padding: ${convertPxToRem(64)} 0rem 0rem;
`;

const AuthProfileWrapperStyled = styled.div`
    padding: 0rem ${convertPxToRem(24)} ${convertPxToRem(24)};
`;
const LogOutButtonWrapperStyled = styled.div`
    margin-bottom: ${convertPxToRem(24)};
    padding: 0rem ${convertPxToRem(24)};
`;

// component
const PanelOverlay = () => {
    return (
        <PanelOverlayContext>
            <PanelOverlayStyled>
                <AuthProfileWrapperStyled>
                    <AuthProfile />
                    <MarketingMessageStyled />
                </AuthProfileWrapperStyled>
                <LogOutButtonWrapperStyled>
                    <LogoutButton />
                </LogOutButtonWrapperStyled>
                <AuthMenus />
            </PanelOverlayStyled>
        </PanelOverlayContext>
    );
};

export default PanelOverlay;
